import React from 'react';

import { ITEM_IMG_URL } from '../config';

const framesCount = 150;
const loopCount = 1;

function getImagesUrl(n, url, type = '.jpg') {
    if (n > framesCount) n = 99;

    return `${ITEM_IMG_URL}${url}/${url.replaceAll('_scrub', '')}_00${n.toString().padStart(3, '0')}${type}`;
}

function imgLoad(url) {
    var img = new Image();

    return new Promise(function (resolve, reject) {
        img.onload = () => resolve(img);
        img.src = url;
    });
}

function linearmap(x, in_min, in_max, out_min, out_max) {
    return ((x - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

const useMount = (mount) => React.useEffect(mount, []);

const useMousePosition = () => {
    const [x, setX] = React.useState(0);
    const [y, setY] = React.useState(0);
    const [isTouching, setIsTouching] = React.useState(false);

    const Mouse = ({ nativeEvent: { offsetX, offsetY } }) => {
        setX(offsetX);
        setY(offsetY);
    };

    const Touch = ({ nativeEvent: { touches } }) => {
        if (!touches[0]) return;
        setX(touches[0].clientX);
        setY(touches[0].clientY);
    };

    const bind = {
        onMouseMove: Mouse,
        onTouchMove: Touch,
        onTouchEnd: (e) => setIsTouching(false),
        onTouchStart: (e) => setIsTouching(true),
    };

    return [x, y, isTouching, bind];
};

export default function imageScrub({ url }) {
    const canvas = React.useRef(null);
    // eslint-disable-next-line
    const [x, y, isTouching, bind] = useMousePosition();
    const [images, setImages] = React.useState([]);

    // loadImages
    const loadImages = () => {
        let promises = [];

        for (let i = 0; i < framesCount; i++) {
            let imageSrc = getImagesUrl(i, url),
                promise = imgLoad(imageSrc);

            promises.push(promise);
        }

        Promise.allSettled(promises).then((results) => {
            const newImages = results.filter((result) => result.status === 'fulfilled').map((result) => result.value);
            setImages(newImages);
        });
    };

    const drawImage = () => {
        if (!canvas.current || images.length < framesCount) return;

        // get the real width & render context
        const brw = canvas.current.getBoundingClientRect().width;
        const ctx = canvas.current.getContext('2d');

        // get the imageIndex
        let index = Math.round(linearmap(x, 0, brw, 1, framesCount * loopCount));

        // normalize image progress
        index = index % framesCount;

        if (!images[index]) return;

        canvas.current.width = images[index].width;
        canvas.current.height = images[index].height;
        ctx.drawImage(images[index], 0, 0);
    };

    // onMount
    useMount(loadImages);

    // onUpdate
    React.useEffect(drawImage, [x, images]);

    return (
        <div className="gif-container" {...bind}>
            <canvas ref={canvas} />
            <div className={`instructions ${isTouching ? 'isTouching' : ''}`}>
                {images.length ? <span>Swipe or Hover</span> : 'Loading...'}
            </div>
        </div>
    );
}
